import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { inject, provideAppInitializer } from '@angular/core';

const initializeIconFont = () => {
  const iconRegistry = inject(MatIconRegistry);
  iconRegistry.setDefaultFontSetClass('bauer-icon');
}
export function provideUiMaterial() {
  return [
    provideAppInitializer(initializeIconFont),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        appearance: 'outline',
      },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 1000, horizontalPosition: 'center' },
    },
  ];
}
